// extracted by mini-css-extract-plugin
module.exports = {"scrollableContent":"sum_scrollableContent_337Sm","message":"sum_message_qMVH7"};